import { useRouteError, Link, useLocation} from "react-router-dom";
import { callAPI } from '../hooks/CallAPI';
import { useLocalStorage } from "../hooks/useLocalStorage";

const ErrorPage = ({ msg = 'Désolé, cette page n\'existe pas.', nowrap = false }) => {
    const error = useRouteError();
    const [user] = useLocalStorage("user", null);
    const location = useLocation();

    const subMessage = error ? "Le Service Technique a été prévenu du problème que vous avez rencontré et va mettre tout en oeuvre pour le corriger au plus vite" : false;

    const renderErrorMessage = () => {
        if (!error) return msg;

        if (typeof error.status !== "undefined" && error.status == 404) {
            //
        }
        else {
            switch (error.constructor) {
                case SyntaxError:
                    return "Erreur de syntaxe détectée.";
                case ReferenceError:
                    return "Erreur de référence détectée.";
                case TypeError:
                    return "Erreur de type détectée.";
                case RangeError:
                    return "Erreur de plage détectée.";
                case URIError:
                    return "Erreur URI détectée.";
                case EvalError:
                    return "Erreur d'évaluation détectée.";
                default:
                    return error.message || msg;
            }
        }
    };

    if (typeof error.status === "undefined") {
        console.log(error);
        // on envoie un mail au Fullstack de Meosis
        const errorData = {
            message: error.message,
            source: error.fileName, // Si disponible
            lineno: error.lineNumber, // Si disponible
            colno: error.columnNumber, // Si disponible
            stack: error.stack,
            page: location.pathname
        };
    
        const responseData = callAPI('/send-error-api', { access_token: user.access_token, error: errorData});
    }

    return (
        <div id="error-page" className={`flex flex-col items-center justify-center ${!nowrap ? "h-screen" : ""}`}>
            <h1 className="text-4xl font-bold text-red-600 mb-4">Oops!</h1>
            <p className="text-lg text-gray-700 mb-2">{renderErrorMessage()}</p>
            {subMessage ?
                <div className="bloc-info my-3 mt-8 flex justify-between items-center">
                    {subMessage}
                </div>
                : ''}
            {!nowrap && (
                <Link to="/" className="bg-mlime text-lg px-6 py-3 rounded-3xl mt-10 flex items-center justify-center text-white font-bold block text-center">
                    Revenir à l'accueil
                </Link>
            )}
        </div>
    );
}

export default ErrorPage;